import {
  PROJECT_ON_BOARD_CREATE_COLLECTION_BEGIN,
  PROJECT_ON_BOARD_CREATE_COLLECTION_SUCCESS,
  PROJECT_ON_BOARD_CREATE_COLLECTION_FAILURE,
  PROJECT_ON_BOARD_CREATE_COLLECTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function createCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_CREATE_COLLECTION_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: PROJECT_ON_BOARD_CREATE_COLLECTION_SUCCESS,
              data: res.data,
            });
            const { collectionName, uuid } = res.data;
            toast.success('Collection Created Successfully !');
            Mixpanel.track('Collection Created on Project Onboarding', { collectionName, uuid });
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: PROJECT_ON_BOARD_CREATE_COLLECTION_FAILURE,
              data: { error: 'Failed' },
            });
            toast.error(`Failed: ${errMsg}`, {});
            Mixpanel.track('Collection Create Failed on Project Onboarding');
            resolve('Failed');
          }
        },
        (err) => {
          console.log('err.response :>> ', err.response);
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Collection Create Failed on Project Onboarding');
          if (err.response.status && err.response.status === 400) {
            dispatch({
              type: PROJECT_ON_BOARD_CREATE_COLLECTION_FAILURE,
              data: { error: errMsg },
            });
            resolve(errMsg);
          }
          dispatch({
            type: PROJECT_ON_BOARD_CREATE_COLLECTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionError() {
  return {
    type: PROJECT_ON_BOARD_CREATE_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_CREATE_COLLECTION_BEGIN:
      return {
        ...state,
        createCollectionPending: true,
        createCollectionError: null,
      };

    case PROJECT_ON_BOARD_CREATE_COLLECTION_SUCCESS:
      return {
        ...state,
        createCollectionPending: false,
        createCollectionError: null,
        projectCollections: [...state.projectCollections, action.data],
        selectedCollection: action.data,
        items: [],
      };

    case PROJECT_ON_BOARD_CREATE_COLLECTION_FAILURE:
      return {
        ...state,
        createCollectionPending: false,
        createCollectionError: action.data.error,
      };

    case PROJECT_ON_BOARD_CREATE_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        createCollectionError: null,
      };

    default:
      return state;
  }
}
